<template>
<div class="snack" :style="color == 'success' ? 'background-color: green' : 'background-color: red'" v-if="active">
    <span>{{msg}}</span>
</div>
</template>

<script>
export default {
    props: ['color', 'msg', 'active', 'duration'],
    watch: {
        active: function () {
            setTimeout(() => {
                this.$emit('deactivate')
            }, this.duration);
        }
    }
}
</script>

<style lang="scss" scoped>
.snack {
    font-family: arial;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    padding: 20px;
    color: white;
}
</style>
